<template>
  <div>
    <div class="m-dashboard-menu px-4 mb-4">
      <router-link v-for="(menu, menuIdx) in mobileCardMenus" v-if="enabledCard(menu)" class="item flex items-center justify-center" style="background: #fff" :to="menu.url" :key="menuIdx">
        <div>
          <div class="mt-4 mb-2 flex justify-center">
            <feather-icon :icon="menu.icon" />
          </div>
          <div class="text-center">
            <span style="font-size: 18px; font-weight: 500; color: #353535">{{ menu.name }}</span>
          </div>
        </div>
      </router-link>
    </div>
    <div class="m-dashboard-info mb-4">
      <div class="item flex bg-white px-4 py-4" style="flex-direction: column">
        <div class="mb-8">
          <h5><i class="dot"></i>디지털 안전·보건관리 시스템 QR코드</h5>
        </div>
        <div class="flex justify-center mb-6">
          <div style="border: 1px solid #cdcdcd; padding: 14px">
            <vue-q-r-code-component :text="qrUrl" :size="140" />
          </div>
        </div>
        <div style="font-size: 14px; font-weight: 400">모바일 카메라로 QR코드를 인식하여 링크를 클릭하면 디지털 안전·보건관리 시스템 홈페이지로 이동합니다.</div>
      </div>

      <div class="m-alarm-list item bg-white px-4 py-4">
        <div>
          <h5>
            <i class="dot"></i>알림현황 <span>(최근 {{ alertList.length }}건)</span>
          </h5>
        </div>
        <div v-for="alert in alertList" :key="alert.message" class="mt-3 p-3 board" @click="onClickAlert(alert)">
          <p style="font-size: 13px; color: #000; font-weight: 400">{{ alert.message }}</p>
          <p class="mt-2" style="font-size: 12px; color: #696d71; font-weight: 400">{{ alert.created_at }}</p>
        </div>
        <div v-if="alertList.length === 0" class="mt-3 p-6 board">
          <p style="font-size: 13px; color: #000; font-weight: 400">미확인 알림이 없습니다</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DonutChartCard from "@/components/DonutChartCard";
import HomeNotificationCard from "@/components/HomeNotificationCard";
import CommunityHealthinfoCard from "@/components/CommunityHealthinfoCard";
import CommunityWorkNewsCard from "@/components/CommunityWorkNewsCard";
import CommunityBusinessNewsCard from "@/components/CommunityBusinessNewsCard";
import DonutChart01 from "@/views/graph/DonutChart01";
import DonutChart02 from "@/views/graph/DonutChart02";
import DonutChart03 from "@/views/graph/DonutChart03";
import DonutChart04 from "@/views/graph/DonutChart04";
import DonutChart05 from "@/views/graph/DonutChart05";
import DonutChart06 from "@/views/graph/DonutChart06";
import DonutChart07 from "@/views/graph/DonutChart07";
import DonutChart08 from "@/views/graph/DonutChart08";
import DonutChart09 from "@/views/graph/DonutChart09";
import DonutChart10 from "@/views/graph/DonutChart10";
import DonutChart11 from "@/views/graph/DonutChart11";
import DonutChart12 from "@/views/graph/DonutChart12";
import DonutChart13 from "@/views/graph/DonutChart13";
import DonutChart14 from "@/views/graph/DonutChart14";
import HealthSafetyBudgetExecutionRateChart from "@/views/graph/HeathSafetyBudgetExecutionRateChart";
import DonutChart16 from "@/views/graph/DonutChart16.vue";
import DonutChart17 from "@/views/graph/DonutChart17.vue";
import DonutChart18 from "@/views/graph/DonutChart18.vue";
import DonutChart19 from "@/views/graph/DonutChart19.vue";
import DonutChart20 from "@/views/graph/DonutChart20.vue";
import DonutChart37 from "@/views/graph/DonutChart37";
import DonutChart09Dbm from "@/views/graph/DonutChart09Dbm.vue";
import VueQRCodeComponent from "vue-qrcode-component";

export default {
  components: {
    DonutChart09Dbm,
    DonutChart37,
    DonutChart20,
    DonutChart19,
    DonutChart18,
    DonutChart17,
    DonutChart16,
    HealthSafetyBudgetExecutionRateChart,
    DonutChart14,
    DonutChart13,
    DonutChart12,
    DonutChart11,
    DonutChart10,
    DonutChart09,
    DonutChart08,
    DonutChart07,
    DonutChart06,
    DonutChart05,
    DonutChart04,
    DonutChart03,
    DonutChart02,
    DonutChart01,
    CommunityBusinessNewsCard,
    CommunityWorkNewsCard,
    CommunityHealthinfoCard,
    HomeNotificationCard,
    DonutChartCard,
    VueQRCodeComponent,
  },
  data() {
    return {
      rootPath: "",
      successLoadGraph: false,
      alertList: [],
    };
  },
  async created() {
    const paths = this.$route.path.split("/");
    this.rootPath = `/${paths[1]}/${paths[2]}`;
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL").then((value) => {
      this.successLoadGraph = true;
    });
  },
  computed: {
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    mobileCardMenus() {
      if (Number(`${this.projectId}`) === 2) {
        return [
          {
            url: `dashboard`,
            name: "스마트 대시보드",
            icon: "PieChartIcon",
            boardId: "",
          },
          {
            url: "tab/161",
            name: "정기 위험성평가(5x4)",
            icon: "AlertTriangleIcon",
            boardId: "161",
          },
          {
            url: "tab/475",
            name: "3등급(상·중·하)판단법",
            icon: "AlertTriangleIcon",
            boardId: "475",
          },
          {
            url: "tab/476",
            name: "주간 이행사항 점검 및 회의",
            icon: "UsersIcon",
            boardId: "476",
          },
          {
            url: "tab/477",
            name: "일일 TBM 활동",
            icon: "UserCheckIcon",
            boardId: "477",
          },
          {
            url: "tab/291",
            name: "안전·보건 순회점검표(현장)",
            icon: "CheckSquareIcon",
            boardId: "291",
          },
        ];
      } else if (Number(`${this.projectId}`) === 6) {
        return [
          {
            url: "tab/587/write",
            name: "위험성평가 사전회의일지",
            icon: "SearchIcon",
            boardId: "587",
          },
          {
            url: "tab/584/write",
            name: "정기 위험성평가(3단계법)",
            icon: "AlertTriangleIcon",
            boardId: "584",
          },
          {
            url: "tab/588/write",
            name: "정기 위험성평가 교육 일지",
            icon: "FileTextIcon",
            boardId: "588",
          },
          {
            url: "tab/589/write",
            name: "수시 위험성평가(OPS)",
            icon: "AlertTriangleIcon",
            boardId: "589",
          },
          {
            url: "tab/590/write",
            name: "수시 위험성평가 교육 일지",
            icon: "FileTextIcon",
            boardId: "590",
          },
          {
            url: "tab/582/write",
            name: "관리자(사업장 순회점검)",
            icon: "PocketIcon",
            boardId: "582",
          },
          {
            url: "tab/581/write",
            name: "근로자(상시제안 및 청취조사)",
            icon: "UserCheckIcon",
            boardId: "581",
          },
        ];
      }
      return [];
    },
    // 현재 페이지의 URL을 반환한다
    qrUrl() {
      return window.location.href;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    myLv() {
      return parseInt(`${this.$store.state.auth.userInfo.position}`);
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const proj of projects) {
          if (proj.id == this.projectId && proj.company.length > 0) {
            const path = proj.company[0].pivot.company_path;
            const lv = path.split("/").length - 1;
            return lv;
          }
        }
      }
    },
    boardIds() {
      return this.$store.state.menu.availableBoardIds;
    },
    companyInfo() {
      return this.$store.state.auth.companyInfo;
    },
    rootCompanyList() {
      const list = [];
      for (const company of this.$store.state.company.companyList) {
        if (typeof company !== "undefined" && typeof company.com_type !== "undefined" && company.com_type === "head") {
          list.push(company);
        }
      }
      return list;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      for (const company of this.rootCompanyList) {
        if (myInfo.company_id === company.id) {
          isAdmin = true;
          break;
        }
      }

      return isAdmin;
    },
    comGroupList() {
      const companyTree = this.$store.state.company.companyTree;
      let maxDepth = 0;
      const list = [];
      let hasRootHead = false;
      const headList = [];

      if (companyTree && companyTree.length > 0) {
        for (const com of companyTree) {
          if (!com || !com.descendant) {
            continue;
          }

          if (typeof com.descendant !== "undefined" && typeof com.descendant.com_type !== "undefined" && com.descendant.com_type === "head") {
            hasRootHead = true;
            headList.push(com.descendant.com_name);
          }
          if (com.depth > maxDepth) {
            maxDepth = com.depth;
          }

          const parentId = com.descendant.parent_id ? com.descendant.parent_id : com.descendant.id;
          if (list[`com_${parentId}`]) {
            list[`com_${parentId}`][com.descendant.id] = com.descendant.com_name;
          } else {
            list[`com_${parentId}`] = { [com.descendant.id]: com.descendant.com_name };
          }
        }
      }

      return {
        maxDepth,
        hasRootHead,
        headList,
        list,
      };
    },
    dataType() {
      if (Number(`${this.comGroupList.maxDepth}`) === 0) {
        return "detail";
      }
      return "company";
    },
  },
  async mounted() {
    await this.loadCompanyList();

    if (this.verticalNavMenuWidth !== "default") {
      await this.loadAlertList();
    }
  },
  methods: {
    async loadCompanyList() {
      const page = 1;
      const perPage = 10000;
      const projectId = this.projectId;
      await this.$store.dispatch("company/LOAD_COMPANY_TREE", { projectId });
      await this.$store.dispatch("company/LOAD_COMPANY_LIST", {
        page,
        perPage,
        comType: "head",
        projectId,
      });
    },

    async loadAlertList() {
      const options = {
        page_unread: 1,
        per_page_unread: 5,
        days_before_unread: 30,

        page_read: 1,
        per_page_read: 5,
        days_before_read: 30,
      };
      if (JSON.stringify(options) === JSON.stringify(this.apiLastLoadOptions)) {
        // 이전과 동일한 옵션으로 리스트를 불러옵니다.
        return;
      }
      this.apiLastLoadOptions = JSON.parse(JSON.stringify(options));
      await this.$store.dispatch("approval/LOAD_NOTIFICATION_LIST", options);

      const readList = this.$store.state.approval.alertReadList;
      const unreadList = this.$store.state.approval.alertUnReadList;

      this.alertList = unreadList;
    },

    enabledCard(menu) {
      // 대시보드는 lv2 이상만 접근 가능
      if (menu.boardId === "" && this.getLevel <= 2) {
        return true;
      }
      // 권한을 갖고 있는 게시판 번호들 중에 해당 게시판이 있는지 확인
      return this.boardIds.includes(Number(`${menu.boardId}`));
    },

    onClickAlert(alert) {
      const data = JSON.parse(alert.data);
      const projectId = data.project_id;
      const boardId = data.board_id;
      const postId = data.post_id;
      this.$router.push({ path: `/project/${projectId}/tab/${boardId}/write/${postId}` });
    },
  },
};
</script>
<style lang="scss" scoped>
.dashboard-layout-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 16px;
  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
}
.dashboard-layout-auto {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1310px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1660px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

.m-dashboard-menu {
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  gap: 1rem;
  .item {
    padding: 0.5rem;
    min-height: 192px;
    margin-bottom: 0rem;
    box-shadow: 0 2px 8px 0 #00000021;
    border-radius: 8px;
    border: 1px solid #00000015;
  }

  @media (max-width: 768px) {
    min-height: 100px;
  }
}
.m-dashboard-info {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 1rem;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    .item {
      margin: 0 14px;
    }
  }
  @media (min-width: 768px) {
    grid-template-columns: 1fr 2fr;

    .item:first-child {
      margin-left: 14px;
    }
    .item:last-child {
      margin-right: 14px;
    }
  }
  @media (min-width: 1200px) {
    grid-template-columns: 1fr 3fr;

    .item:first-child {
      margin-left: 14px;
    }
    .item:last-child {
      margin-right: 14px;
    }
  }
  .item {
    padding: 0.5rem;
    min-height: 192px;
    margin-bottom: 0rem;
    box-shadow: 0 2px 8px 0 #00000021;
    border-radius: 8px;
    border: 1px solid #00000015;
  }
}
.m-alarm-list {
  width: auto;
  .board {
    border: 1px solid #cdcdcd;
  }
}
</style>
